module.exports = __webpack_public_path__ + "img/arrow.25a64f0f.png";